module.exports = __webpack_public_path__ + "img/nurse.ede5bded.png";